import React, { useEffect, useRef, useState } from "react";
import { ACTIONARROW_ICON, DELETE_ICON, EDIT_ICON, RIGHTARROW_ICON } from "../../../utills/image-constant";
import AdminDataTable from "../../components/common/AdminDataTable";
import TableHeading from "../../components/common/TableHeading";
import SearchAndAddItem from "../../components/common/TableData";
import Modal from "../../components/common/Model";
import Inputwithlable from "../../components/common/inputwithlable";
import { addAdminModel, deleteModalById, getAdminModelBlock, getallAdminModel } from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import moment from "moment";
import SuccessModel from "../../components/common/SuccessModel";
import { useSelector } from "react-redux";
import AccessPermissionpage from "./AccessPermissionpage";
import DeleteModal from "../../components/common/DeleteModal";
import { API_RESPONSE } from "../../../utills/app-constant";

const ModalManagement = () => {
  const [pending, setPending] = useState(false); // Used for loading state
  const [totalElement, settotalElement] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [sortColumn, setSortColumn] = useState("id");

  const [sortDirection, setSortDirection] = useState("desc");
  const [modelPayload, setModelPayload] = useState({
    id: "",
    modelName: "",
    sortName: "",
  });

  const [isEditMode, setIsEditMode] = useState(false); // Track if in edit mode
  const [isViewMode, setIsViewMode] = useState(false);
  const [viewModelId, setViewModelId] = useState(false)
  const [editModelId, setEditModelId] = useState(null); // Store model ID being edited
  const [rowData, setRowData] = useState([]);
  const addbuttonClick = useRef();
  const successModalRef = useRef();
  const DeleteModalRef = useRef()
  const { value } = useSelector((state) => state?.adminRole);
  const [permissionAccess, setPermissionAccess] = useState();
  const [deleteModelId, setDeleteModelId] = useState(null);
   const [deleteModelName, setDeleteModelName] = useState();
  useEffect(() => {
    const FlashAssessmentFilterData = value?.filter(
      (v) => v.moduleName === "Assessment Modeling"
    );
    setPermissionAccess(FlashAssessmentFilterData?.[0]);
  }, [value]);


  const addButtonClick = () => {
    setIsEditMode(false);
    setIsViewMode(false)
    setModelPayload({ id: "", modelName: "", sortName: "" });
    addbuttonClick.current.click();
  };

  const editButtonClick = (model) => {
    setIsEditMode(true);
    setModelPayload({
      id: model.id,
      modelName: model.modelName,
      sortName: model.sortName,
    });
    setEditModelId(model.id);
    addbuttonClick.current.click();
  };
  const viewButtonClick = (model) => {
    setIsViewMode(true);
    setModelPayload({
      id: model.id,
      modelName: model.modelName,
      sortName: model.sortName,
    });
    setViewModelId(model.id);
    addbuttonClick.current.click();
  };

  const getListOfModel = async () => {
    try {
      setPending(true); // Start loading
      const response = await getallAdminModel(
        page,
        pageSize,
        searchValue,
        sortDirection,
        sortColumn
      );
      if (response?.data?.responseCode === 200) {
        setRowData(response?.data?.responseBody?.modelResponsePayloadList);
        settotalElement(response?.data?.responseBody?.totalElement);
      } else {
        setRowData([]);
      }
      setPending(false); // Stop loading
    } catch (err) {
      setPending(false); // Stop loading if error occurs
      console.error(err);
    }
  };

  useEffect(() => {
    getListOfModel();
  }, [page, pageSize, totalElement, searchValue, sortColumn, sortDirection]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setModelPayload((prevPayload) => ({
      ...prevPayload,
      [name]: value,
    }));
  };

  function checkProperties(obj) {
    for (var key in obj) {
      if (obj[key] !== null && obj[key] !== "") return false;
    }
    return true;
  }

  const onAddOrEditModel = async () => {
    const isEmpty = checkProperties(modelPayload);
    if (isEmpty) {
      return toastEmitter(
        "error",
        "Fields marked with an asterisk (*) are required!"
      );
    }
    if (modelPayload.modelName === null || modelPayload.modelName?.trim() === "") {
      return toastEmitter("error", "Name Is Required!");
    }
    if (modelPayload.sortName === null || modelPayload.sortName?.trim() === "") {
      return toastEmitter("error", "Sort Name Is Required!");
    }
    try {
      let response = await addAdminModel(modelPayload);
      if (response?.data?.responseCode === 200) {
        successModalRef.current.click();
        getListOfModel();
        addbuttonClick.current.click(); // Close the add/edit modal
      } else if (response?.data?.responseCode === 400) {
        toastEmitter("error", response?.data?.message);
      } else {
        console.error("Failed to add or edit model");
      }
    } catch (error) {
      console.error("Error during add/edit model:", error);
    }
  };

  const handleStatusChange = async (row) => {
    const newStatus = row?.status === 1 ? 0 : 1; // Toggle the status

    // Optimistically update the status in the local rowData
    const updatedRowData = rowData.map((item) =>
      item.id === row.id ? { ...item, status: newStatus } : item
    );
    setRowData(updatedRowData); // Update local state with the new status

    try {
      let response = await getAdminModelBlock(row.id, newStatus);

      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
      } else {
        // If the API fails, revert the status in local state
        const revertRowData = rowData.map((item) =>
          item.id === row.id ? { ...item, status: row?.status } : item
        );
        setRowData(revertRowData);
        console.error("Failed to update model status");
      }
    } catch (error) {
      // If there's an error, revert the status in local state
      const revertRowData = rowData.map((item) =>
        item.id === row.id ? { ...item, status: row?.status } : item
      );
      setRowData(revertRowData);
      console.error("Error during status change:", error);
    }
  };

  const deleteButtonClick = (id,name) => {
    setDeleteModelId(id)
    setDeleteModelName(name)
    DeleteModalRef.current.click();
  }

  const tblColumns = [
    ...(permissionAccess?.updateAction === 1
      ? [
        {
          code: "Action",
          name: "Action",
          width: "120px",
          sortable: false,
          cell: (row) => (
            <div>
              <button
                className="border-0 bg-white"
                onClick={() => editButtonClick(row)}
              >
                <img src={EDIT_ICON} alt="Edit" className="editicon" />
              </button>
              <span>
                <button
                  className="border-0 bg-white"
                  onClick={() => viewButtonClick(row)}
                >  <img src={ACTIONARROW_ICON} alt="View" className="editicon ms-2" />
                </button>
              </span>
              <span className="ms-2">
                <button
                  className="border-0 bg-white "
                  onClick={() => deleteButtonClick(row?.id,row?.modelName)}
                >  <img src={DELETE_ICON} alt="View" className="editicon" />
                </button>
              </span>
            </div>
          ),
        },
      ]
      : []),
    {
      code: "modelId",
      name: "Model Id",
      width: "100px",
      sortable: true,
      selector: (row) => `${row?.modelId}`,
    },
    {
      code: "modelName",
      name: "Model Name",
      width: "250px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.modelName}</div>
      ),
    },
    {
      code: "sortName",
      name: "Short Name",
      width: "250px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.sortName}</div>
      ),
    },
    {
      code: "status",
      name: "Status",
      width: "220px",
      omit: false,
      sortable: true,
      cell: (row) => (
        <div className="form-switch-btn">
          <label className="switch">
            <input
              disabled={permissionAccess?.moduleAction === 0}
              type="checkbox"
              id="togBtn"
              checked={row?.status === 1}
              onChange={() => handleStatusChange(row)}
            />
            <div className="slider round">
              {row?.status === 1 ? (
                <span className="on">Active</span>
              ) : (
                <span className="off">Inactive</span>
              )}
            </div>
          </label>
        </div>
      ),
    },
    {
      code: "updatedDate",
      name: "Last Update",
      sortable: true,
      selector: (row) => moment(row?.updatedDate).format("MM/DD/YYYY"),
    },

  ];

  const onSearchChange = (e) => {
    setSearchValue(e.target.value);
  };


  const handleModalDelete = async () => {
    try {
      const response = await deleteModalById(deleteModelId);
      // console.log("response------------", response);

      if (response?.data?.responseCode === 200) {
        toastEmitter('success', response.data.message)
        getListOfModel();
      } else {
        toastEmitter('error', response.data.message || API_RESPONSE?.MESSAGE_500)
      }
    } catch (err) {
      // toastEmitter('error', response.data.message || API_RESPONSE?.MESSAGE_500)
    }
  }


  return (
    <>
      {permissionAccess?.addAction === 0 &&
        permissionAccess?.updateAction === 0 &&
        permissionAccess?.viewAction === 0 ? (
        <AccessPermissionpage />
      ) : (
        <>
          <div className="modal_datatable">
            <TableHeading
              firstData="Assessment Modeling"
              icon={RIGHTARROW_ICON}
              secondData="Model Management"
            />
            <div className="container-fluid">
              <div className="caspera_admin_datatable mb-3">
                <SearchAndAddItem
                  // title="Models"
                  searchValue={searchValue}
                  onSearchChange={onSearchChange}
                  data="Model"
                  addButtonClick={addButtonClick}
                  addbuttonClick={addbuttonClick}
                  permissionAccessbtn={permissionAccess?.addAction}
                />
                {/* Loading Spinner */}
                {/* {pending ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                  </div>
                ) : ( */}
                <AdminDataTable
                  _tblColumns={tblColumns}
                  _rowData={rowData}
                  tableCustomStyles={{}}
                  _totalRows={totalElement}
                  pending={pending}

                  setPending={setPending}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  setPage={setPage}
                  setSortColumn={setSortColumn}
                  setSortDirection={setSortDirection}
                />
                {/* )} */}
              </div>
            </div>
          </div>

          <Modal
            modalClick={addbuttonClick}
            title={isViewMode ? "View Model" : isEditMode ? "Update Model" : "Add Model"}
            onAddItem={onAddOrEditModel}
            buttonLable={isViewMode ? "" : isEditMode ? "Update" : "Add"}
          >
            <div className="row">
              <div className="col-md-12">
                <Inputwithlable
                  placeHolder="Enter Model Name"
                  name="modelName"
                  type="text"
                  showastrict={true}
                  labelName="Enter Model Name"
                  lableclassName="input-label"
                  className="form-control inputText-lable"
                  value={modelPayload.modelName}
                  handleChange={handleChange}
                  maxlng={64}
                  disable={isViewMode}
                />
              </div>
              <div className="col-md-12">
                <Inputwithlable
                  placeHolder="Enter Label"
                  name="sortName"
                  type="text"
                  labelName="Enter Short Name"
                  lableclassName="input-label"
                  className="form-control inputText-lable"
                  value={modelPayload.sortName}
                  handleChange={handleChange}
                  showastrict={true}
                  maxlng={64}
                  disable={isViewMode}
                />
              </div>
            </div>
          </Modal>
          <SuccessModel
            title={isEditMode ? "Model Updated" : "Model Added"}
            SuccessModel={successModalRef}
          />
          <DeleteModal
            DeleteModalRef={DeleteModalRef}
            title="Model"
            name={deleteModelName}
            warningMsg="⚠️If you delete this model. All the Dimensions, Sub-dimensions and criteria associated with it will automatically deleted."
            handleDelete={handleModalDelete}
          />
        </>
      )}
    </>
  );
};

export default ModalManagement;
